import React from 'react'
import { Link, LinkProps, useNavigate } from 'react-router-dom'
import { RoleType } from '../../../models/User'
import { selectUserData } from '../../../redux/actions/login/loginSlice'
import { useAppSelector } from '../../../redux/hooks'
import { resolveAdminPanelPath } from '../../../utils/permissionUtil'

function shouldUseAdminPaths(role?: RoleType): boolean {
  if (role && role !== RoleType.user) return true
  return typeof window !== 'undefined' && window.location.pathname.startsWith('/admin')
}

export const CustomLink = React.memo(({ children, to, ...props }: LinkProps) => {
  const userState = useAppSelector(selectUserData)
  const urlPrefix = React.useMemo(() => {
    const toStr = String(to)
    if (shouldUseAdminPaths(userState.user.role as RoleType | undefined)) {
      return resolveAdminPanelPath(toStr)
    }
    return to
  }, [userState.user.role, to])

  return (
    <Link to={urlPrefix} {...props}>
      {children}
    </Link>
  )
})

export const useNavigateCustom = () => {
  const navigate = useNavigate()
  const userSate = useAppSelector(selectUserData)

  const push = React.useCallback((to: any, state: any) => navigate(to, { state }), [])

  const replace = React.useCallback(
    (to: any, state: any) => navigate(to, { replace: true, state }),
    [],
  )

  const go = React.useCallback(
    (delta: any) => {
      const path = String(delta)
      if (shouldUseAdminPaths(userSate.user.role as RoleType | undefined)) {
        return navigate(resolveAdminPanelPath(path))
      }
      return navigate(path)
    },
    [userSate.user.role, navigate],
  )

  const back = React.useCallback(() => navigate(-1), [])

  const forward = React.useCallback(() => navigate(1), [])

  return {
    back,
    forward,
    go,
    push,
    replace,
  }
}
